function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Pagination/Next");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Pagination/Next",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.1096875,16.7903125 C13.5159375,16.7903125 13.820625,16.485625 13.820625,16.079375 C13.820625,15.8840625 13.7425,15.704375 13.6175,15.5715625 L7.93,10.0090625 L13.6175,4.4465625 C13.7425,4.31375 13.820625,4.12625 13.820625,3.93875 C13.820625,3.5325 13.5159375,3.22 13.1096875,3.22 C12.9065625,3.22 12.7346875,3.298125 12.601875,3.4309375 L6.414375,9.485625 C6.2659375,9.610625 6.18,9.8059375 6.18,10.0090625 C6.18,10.204375 6.258125,10.3840625 6.4065625,10.5325 L12.601875,16.579375 C12.7346875,16.7121875 12.9065625,16.7903125 13.1096875,16.7903125 Z",
  id: "ic-next",
  fill: "#70707D",
  fillRule: "nonzero",
  transform: "translate(10.000313, 10.005156) rotate(-180.000000) translate(-10.000313, -10.005156) "
}));

var SvgNext = function SvgNext(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNext, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next.a6509b99.svg";
export { ForwardRef as ReactComponent };